import logo1 from "../../assets/img/ple/mitb/logos/2010-2011.png";
import logo2 from "../../assets/img/ple/mitb/logos/2012.png";
import logo3 from "../../assets/img/ple/mitb/logos/2013-2014.png";
import logo4 from "../../assets/img/ple/mitb/logos/2015.png";
import logo5 from "../../assets/img/ple/mitb/logos/2016.png";
import logo6 from "../../assets/img/ple/mitb/logos/2017.png";
import logo7 from "../../assets/img/ple/mitb/logos/2018-2021.png";
import logo8 from "../../assets/img/ple/mitb/logos/2022.png";
import logo9 from "../../assets/img/ple/mitb/logos/2023.png";
import logo10 from "../../assets/img/ple/mitb/logos/2024.png";
import logo11 from "../../assets/img/ple/mitb/logos/2025.png";
import logo12 from "../../assets/img/ple/mitb/logos/2026.png";

import winner1 from "../../assets/img/ple/mitb/winners/1.png";
import winner2 from "../../assets/img/ple/mitb/winners/2.png";
import winner3 from "../../assets/img/ple/mitb/winners/3.png";
import winner4 from "../../assets/img/ple/mitb/winners/4.png";
import winner5 from "../../assets/img/ple/mitb/winners/5.png";
import winner6 from "../../assets/img/ple/mitb/winners/6.png";
import winner7 from "../../assets/img/ple/mitb/winners/7.png";
import winner8 from "../../assets/img/ple/mitb/winners/8.png";
import winner9 from "../../assets/img/ple/mitb/winners/9.png";
import winner10 from "../../assets/img/ple/mitb/winners/10.png";
import winner11 from "../../assets/img/ple/mitb/winners/11.png";
import winner12 from "../../assets/img/ple/mitb/winners/12.png";
import winner13 from "../../assets/img/ple/mitb/winners/13.png";
import winner14 from "../../assets/img/ple/mitb/winners/14.png";
import winner15 from "../../assets/img/ple/mitb/winners/15.png";
import winner16 from "../../assets/img/ple/mitb/winners/16.png";
import winner17 from "../../assets/img/ple/mitb/winners/17.png";
import winner18 from "../../assets/img/ple/mitb/winners/18.png";
import winner19 from "../../assets/img/ple/mitb/winners/19.png";
import winner20 from "../../assets/img/ple/mitb/winners/20.png";
import winner21 from "../../assets/img/ple/mitb/winners/21.png";
import winner22 from "../../assets/img/ple/mitb/winners/22.png";
import winner23 from "../../assets/img/ple/mitb/winners/23.png";
import winner24 from "../../assets/img/ple/mitb/winners/24.png";
import winner25 from "../../assets/img/ple/mitb/winners/25.png";

export const moneyInTheBankDetail = {
  id: "mitb",
  title: "Money in the Bank",
  subtitle: "Explore winners and event editions in a dedicated event view.",
  tabs: [
    {
      id: "winners",
      label: "Winners",
      variant: "money-in-the-bank",
      items: [
        {
          id: "winner1",
          title: "Edge",
          description: "WrestleMania 21 - 2005",
          imgUrl: winner1,
        },
        {
          id: "winner2",
          title: "Rob Van Dam",
          description: "WrestleMania 22 - 2006",
          imgUrl: winner2,
        },
        {
          id: "winner3",
          title: "Mr. Kennedy & Edge",
          description: "WrestleMania 23 - 2007",
          imgUrl: winner3,
        },
        {
          id: "winner4",
          title: "CM Punk",
          description: "WrestleMania XXIV & 25 - 2008 - 2009",
          imgUrl: winner4,
        },
        {
          id: "winner5",
          title: "Jack Swagger",
          description: "WrestleMania XXVI - 2010",
          imgUrl: winner5,
        },
        {
          id: "winner7",
          title: "Kane",
          description: "SMACKDOWN Money In The Bank 2010",
          imgUrl: winner7,
        },
        {
          id: "winner6",
          title: "The Miz",
          description: "RAW Money In The Bank 2010",
          imgUrl: winner6,
        },
        {
          id: "winner8",
          title: "Alberto Del Rio",
          description: "RAW Money In The Bank 2011",
          imgUrl: winner8,
        },
        {
          id: "winner9",
          title: "Daniel Bryan",
          description: "SMACKDOWN Money In The Bank 2011",
          imgUrl: winner9,
        },
        {
          id: "winner11",
          title: "Dolph Ziggler",
          description: "SMACKDOWN Money In The Bank 2012",
          imgUrl: winner11,
        },
        {
          id: "winner10",
          title: "John Cena",
          description: "RAW Money In The Bank 2012",
          imgUrl: winner10,
        },
        {
          id: "winner13",
          title: "Damien Sandow",
          description: "SMACKDOWN Money In The Bank 2013",
          imgUrl: winner13,
        },
        {
          id: "winner12",
          title: "Randy Orton",
          description: "RAW Money In The Bank 2013",
          imgUrl: winner12,
        },
        {
          id: "winner14",
          title: "Seth Rollins",
          description: "Money In The Bank 2014",
          imgUrl: winner14,
        },
        {
          id: "winner15",
          title: "Sheamus",
          description: "Money In The Bank 2015",
          imgUrl: winner15,
        },
        {
          id: "winner16",
          title: "Dean Ambrose",
          description: "Money In The Bank 2016",
          imgUrl: winner16,
        },
        {
          id: "winner17",
          title: "Baron Corbin",
          description: "SMACKDOWN Money In The Bank 2017",
          imgUrl: winner17,
        },
        {
          id: "winner18",
          title: "Braun Strowman",
          description: "Money In The Bank 2018",
          imgUrl: winner18,
        },
        {
          id: "winner19",
          title: "Brock Lesnar",
          description: "Money In The Bank 2019",
          imgUrl: winner19,
        },
        {
          id: "winner20",
          title: "Otis & The Miz",
          description: "Money In The Bank 2020",
          imgUrl: winner20,
        },
        {
          id: "winner21",
          title: "Big E",
          description: "Money In The Bank 2021",
          imgUrl: winner21,
        },
        {
          id: "winner22",
          title: "Theory",
          description: "Money In The Bank 2022",
          imgUrl: winner22,
        },
        {
          id: "winner23",
          title: "Damian Priest",
          description: "Money In The Bank 2023",
          imgUrl: winner23,
        },
        {
          id: "winner24",
          title: "Drew McIntyre",
          description: "Money In The Bank 2024",
          imgUrl: winner24,
        },
        {
          id: "winner25",
          title: "Seth Rollins",
          description: "Money In The Bank 2025",
          imgUrl: winner25,
        },
      ],
    },
    {
      id: "logos",
      label: "Editions",
      variant: "money-in-the-bank",
      items: [
        {
          id: "mitb-logo-main",
          title: "Money In The Bank",
          description: "2010 - 2011",
          imgUrl: logo1,
        },
        {
          id: "mitb-logo-2012",
          title: "Money In The Bank",
          description: "2012",
          imgUrl: logo2,
        },
        {
          id: "mitb-logo-2013-2014",
          title: "Money In The Bank",
          description: "2013 - 2014",
          imgUrl: logo3,
        },
        {
          id: "mitb-logo-2015",
          title: "Money In The Bank",
          description: "2015",
          imgUrl: logo4,
        },
        {
          id: "mitb-logo-2016",
          title: "Money In The Bank",
          description: "2016",
          imgUrl: logo5,
        },
        {
          id: "mitb-logo-2017",
          title: "Money In The Bank",
          description: "A golden opportunity awaits 2017",
          imgUrl: logo6,
        },
        {
          id: "mitb-logo-2018",
          title: "Money In The Bank",
          description:
            "Irresistible force meets the meanest woman on the planet 2018",
          imgUrl: logo7,
        },
        {
          id: "mitb-logo-2019",
          title: "Money In The Bank",
          description: "2019",
          imgUrl: logo7,
        },
        {
          id: "mitb-logo-2020",
          title: "Money In The Bank",
          description: "Climb the corporate ladder The risk worth reward 2020",
          imgUrl: logo7,
        },
        {
          id: "mitb-logo-2021",
          title: "Money In The Bank",
          description: "2021",
          imgUrl: logo7,
        },
        {
          id: "mitb-logo-2022",
          title: "Money In The Bank",
          description: "2022",
          imgUrl: logo8,
        },
        {
          id: "mitb-logo-2023",
          title: "Money In The Bank",
          description: "2023",
          imgUrl: logo9,
        },
        {
          id: "mitb-logo-2024",
          title: "Money In The Bank",
          description: "2024",
          imgUrl: logo10,
        },
        {
          id: "mitb-logo-2025",
          title: "Money In The Bank",
          description: "The Last Time is Now 2025",
          imgUrl: logo11,
        },
        {
          id: "mitb-logo-2026",
          title: "Money In The Bank",
          description: "New Orleans 2026",
          imgUrl: logo12,
        },
      ],
    },
  ],
};
